import React,{useEffect,useState} from 'react'
import TextField from '../../components/TextField'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useUpdateBranch} from '../../hooks/branches/useUpdate'

const UpdateBranch = ({branch}) => {
    // STATES
    // PAYLOAD STATE
    const [state,setState]=useState({
        branchId:branch.branchId,
        branchCode:branch.branchCode,
        branchName:branch.branchName,
        activeStatus:branch.activeStatus
    })
    // MISC STATE
    const [error,setError]=useState("")
    const [success,setSuccess]=useState("")

    // MUTATION
    const {mutate:updateBranch,error:updateError,isLoading,isSuccess}=useUpdateBranch(branch.branchId,state)
    
    // HANDLERS
    // INPUT HANDLER
    const handleChange=({target:{name,value}})=>{
            setState({...state,[name]:value})
    }

    const handleCheck=()=>{
        setState({...state,activeStatus:!state.activeStatus})
    }

    // SUBMIT HANDLER
    const handleSubmit=(e)=>{
        e.preventDefault();
        // REFRESH ERROR
        setError('')
        if(state.branchCode==0||state.branchCode.toString().length!=3){ setError("Please enter a valid branch code"); return}
        updateBranch()
    }

    // EFFECTS
    useEffect(()=>{
        if(isSuccess){
            setSuccess("Branch updated successfully")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    },[isSuccess])

    useEffect(()=>{
        if(updateError){
            const message=updateError?.response?.data?.message
            setError(message)
        }
    },[updateError])
    return (
        <form className='w-full flex flex-col space-y-5' onSubmit={handleSubmit}>
            {success.length>0&&<Success>{success}</Success>}
            {error.length>0&&<Error>{error}</Error>}
            <TextField label='Branch Code' required name='branchCode' type={"number"} value={state.branchCode} onChange={handleChange} />
            <TextField label='Branch Name' required name='branchName' value={state.branchName} onChange={handleChange}/>
           {!branch.activeStatus&& <TextField type='checkbox' label='Activate' name='activeStatus' checked={state.activeStatus} onChange={handleCheck} />}
            <SubmitButton loading={isLoading}>Submit</SubmitButton>
        </form>
    )
}

export default UpdateBranch
